import {statuses} from '@priority-software/priority-proto-api/lib/wcfclient';
import {priority} from '@priority-software/priority-proto-api/lib/nform';
import {getAdditionalProps} from '../../../services/proto/core/loginProps';

export const getStatuses = async (Fname: string) => {
    try {
        const res = await statuses(
            new priority.netitems.form.StatusesRq({
                Properties: getAdditionalProps(),
                Fname
            })
        );

        return res.Statuses;
    } catch (e) {
        console.error(e);
        return [];
    }
};
